module.exports = __webpack_public_path__ + "img/pic-03.4d783f46.png";